import React, { Component, Fragment, useEffect  } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import logo from '../../logo.svg';
import '../../App.css';
import RedirectPage from '../common/utils/RedirectPage';
import NotFound from '../layout/NotFound';
import HomePage from '../../features/homePage/HomePage';

function App() {

 

  useEffect(() => {
    // Check if the browser is Internet Explorer
    let isIE = !!window.MSInputMethodContext && !!document.documentMode;
    
    // Additional check for older IE versions
    if (!isIE) {
        const ua = window.navigator.userAgent;
        isIE = ua.indexOf('MSIE ') > 0;
    }

    // Display an alert if it's Internet Explorer
    if (isIE) {
        alert(
            'This browser is not supported. \r\nPlease use Chrome, Microsoft Edge, or Firefox.'
        );
    }
}, []); // Empty dependency array to run only once

useEffect(() => {
  const handleMessage = (event) => {
    // ✅ Validate the sender
    if (event.origin !== process.env.REACT_APP_API_URL_SELF_SERVICE_ORIGIN) return;

    console.log('Message received in iframe:', event.data);

    // ✅ Act based on message content
    if (event.data?.content === 'AVAReset') {
      console.log('Received AVAOpen, show welcome or trigger UI state.');
      window.location.reload();
      // trigger UI change / open chat, etc.
    }
  };

  window.addEventListener('message', handleMessage);

  return () => {
    window.removeEventListener('message', handleMessage);
  };
}, []);

  return (
    <Router>
    <Fragment>
      <Routes>
        <Route path={process.env.REACT_APP_SITE_URL} element={<HomePage />} />
        {/* <Route path="/" element={<HomePage />} /> */}
        <Route
          path={`${process.env.REACT_APP_SITE_URL}/*`}
            // path="/*"
          element={
            <Fragment>
              <Container className="main">
                <Helmet>
                  <title>Road to Literacy</title>
                  <meta name="description" content="Avbob Road to Literacy" />
                </Helmet>
                <Routes>
                  <Route path="/redirect/:token" element={<RedirectPage />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Container>
            </Fragment>
          }
        />
      </Routes>
    </Fragment>
  </Router>
  );
}

export default App;
